// Re-export all Vietnamese translations from modular files
// This file has been refactored into domain-specific modules

import { commonVi } from './vi/common';
import { shippingVi } from './vi/shipping';
import { vehicleVi } from './vi/vehicle';
import { fuelVi } from './vi/fuel';
import { pricingVi } from './vi/pricing';
import { userVi } from './vi/user';
import { reportsVi } from './vi/reports';
import { systemVi } from './vi/system';

export const vi = {
  ...commonVi,
  ...shippingVi,
  ...vehicleVi,
  ...fuelVi,
  ...pricingVi,
  ...userVi,
  ...reportsVi,
  ...systemVi,
  // AI Model Configuration
  'ai.model.configuration': 'Cấu hình mô hình AI',
  'ai.models': 'Mô hình AI',
  'add.ai.model': 'Thêm mô hình AI',
  'edit.ai.model': 'Chỉnh sửa mô hình AI',
  'model.name': 'Tên mô hình',
  'model.description': 'Mô tả',
  'model.purpose': 'Mục đích',
  'selected.model': 'Đã chọn',
  'select.model': 'Chọn',
  'ai.model.created': 'Đã tạo mô hình AI thành công',
  'ai.model.updated': 'Đã cập nhật mô hình AI thành công',
  'ai.model.deleted': 'Đã xóa mô hình AI thành công',
  'ai.model.selected': 'Đã chọn mô hình AI thành công',
  'confirm.delete.ai.model': 'Bạn có chắc chắn muốn xóa mô hình AI này?',
  'cannot.delete.selected.model': 'Không thể xóa mô hình AI đang được chọn',
  'no.ai.models.available': 'Không có mô hình AI nào',
  'enter.model.name': 'Vui lòng nhập tên mô hình',
  'select.model.purpose': 'Vui lòng chọn mục đích mô hình',

  // Model Purposes
  'model.purpose.document.type.detection': 'Phát hiện loại tài liệu',
  'model.purpose.document.processing': 'Xử lý tài liệu (Chung)',
  'model.purpose.document.processing.pdf': 'Xử lý tài liệu - PDF',
  'model.purpose.document.processing.image': 'Xử lý tài liệu - Hình ảnh',
  'model.purpose.telegram.chat': 'Chat Telegram',

  // Telegram
  'telegram.chat.model': 'Mô Hình AI Chat Telegram',
  'telegram.chat.model.active': 'Mô hình này xử lý phản hồi chat bot Telegram với công cụ MCP.',
  'telegram.chat.model.not.configured': 'Chưa chọn mô hình Chat Telegram',
  'telegram.chat.model.not.configured.desc': 'Thêm mô hình AI TelegramChat để kích hoạt phản hồi chat thông minh.',
  'telegram.chat.model.available': 'có sẵn',
};
